import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class BUTransferAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUTransfers';
  /**
   * Sinh dữ liệu chuyển khoản kho bạc từ Rút dụ toán chuyển khoản
   * NXCHIEN 05.07.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu chuyển khoản kho bạc có liên quan rút dự toán
   * tbngoc 21.07.2022
   */
  getDataWithDrawRelation(idWithDraw) {
    let request = { url: [this.getAPIUrl(), `DataWithDraw?idWithDraw=${idWithDraw}`].join('/') };
    return httpClient.getAsync(request);
  }
  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT
   * @param {*} refId
   * @returns
   */
  getDataForEnterPaymentContent(refId) {
    let request = { url: [this.getAPIUrl(), `GetDataForEnterPaymentContent?refId=${refId}`].join('/') };
    return httpClient.getAsync(request);
  }
  /**
 * Lấy thông tin các thông tư theo database
 * TVDAT 29/05/2023
 */
  getCircularInfo(databaseId) {
    let request = {
      url: [this.getAPIUrl(), `circularInfo`].join('/'),
      data: { databaseId }
    };
    return httpClient.getAsync(request);
  }

  /**
   * Check xem có được sinh từ Rút dự toán tiền gửi không
   * NHANH3 24.07.2023
   */
  CheckGenerateBUPlanWithdrawDeposit(payload) {
    let request = {
      url: this.getAPIUrl() + '/CheckGenerateBUPlanWithdrawDeposit',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Validate sinh dữ liệu đã ghi sôr
   * TBNGOc 21.07.2022
   */
  validateGenerateVoucherPosted(payload) {
    let request = {
      url: this.getAPIUrl() + '/ValidateGenerateVoucherPosted',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new BUTransferAPI();
